import { Oval } from "react-loader-spinner";

function DownloadExcelButton({ onClicked, isLoading, title = "Download Excel" }) {
  return (
    <div
      onClick={() => !isLoading && onClicked()}
      className={`${
        isLoading ? "cursor-not-allowed" : "cursor-pointer"
      } flex h-[32px] items-center justify-center gap-[8px] rounded-[8px] bg-[#0065FD] px-[12px]`}
    >
      {isLoading ? (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFFFFF"
          strokeWidth={8}
          secondaryColor="#FFEEFF"
          ariaLabel="oval-loading"
        />
      ) : (
        <>
          <img src="/images/common/download.svg" alt="" className="h-[16px] w-[16px]" />
          <span className="font-OpenSansRegular text-[14px] font-[600] capitalize leading-[20px] tracking-[0.14px] text-white">
            {title}
          </span>
        </>
      )}
    </div>
  );
}

export default DownloadExcelButton;
